<template>
  <v-row class="mt-5 mx-8 mb-10 d-flex">
    <v-col
      cols="12"
      xs="12"
      sm="12"
      md="12"
      lg="4"
      xl="3"
      class="d-flex align-stretch"
    >
      <v-col id="recent-projects" class="ma-0 pa-0">
        <h3 class="text-h5 project-title ma-5">Resource Utilization</h3>
        <v-card
          class="pa-10 flex-grow-1 custom-scrollbar"
          style="overflow-x: scroll; min-height: 410px;"
          :style="{
            border: '1px solid var(--primary-boarder-color)',
          }"
        >
          <apexchart
            ref="resourceChart"
            :options="resourceChartOptions"
            type="donut"
            height="350"
            :series="resourceChartOptions.series"
            style="min-width: 200px;"
          ></apexchart>
        </v-card>
      </v-col>
    </v-col>

    <v-col
      cols="12"
      xs="12"
      sm="12"
      md="12"
      lg="8"
      xl="9"
      class="d-flex align-stretch"
    >
      <v-col id="recent-projects" class="ma-0 pa-0">
        <h2 class="text-h5 project-title ma-5">Overdue / Due statistics</h2>
        <v-card
          class="pa-4 flex-grow-1 custom-scrollbar"
          style="overflow-x: scroll; min-height: 410px;"
          :style="{
            border: '1px solid var(--primary-boarder-color)',
          }"
        >
          <apexchart
            ref="chart"
            :options="chartOptions"
            type="bar"
            height="350"
            :series="chartOptions.series"
            style="min-width: 890px;"
          ></apexchart>
        </v-card>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { ProjectService } from "@/services/project-service.js";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      daysOfWeek: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      dailyProjects: [10, 10, 10, 10, 10, 10, 10],
      overdueProjects: [5, 5, 5, 5, 5, 5, 5],
      dueTodayProjects: [3, 3, 3, 3, 3, 3, 3],
      resourceUtilization: [1, 1],
      loading: false,
      chartOptions: {
        series: [
          {
            name: "Daily Projects",
            data: [],
          },
          {
            name: "Overdue Projects",
            data: [],
          },
          {
            name: "Due Today Projects",
            data: [],
          },
        ],
        colors: [
          "var( --color-primary-blue-light)",
          "var( --color-primary-blue-light-2)",
          "var(--color-primary-blue)",
        ],
        chart: {
          height: 450,
          responsive: true,
          toolbar: {
            show: false,
          },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 900,
            },
          },
          dropShadow: {
            enabled: false,
            color: "#999",
            top: 15,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
        },
        stroke: {
          curve: "smooth",
          width: 0,
        },
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        xaxis: {
          categories: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
        },
        yaxis: {
          title: {
            text: "",
          },
        },
      },
      resourceChartOptions: {
        series: [],
        labels: ["Available", "Not Available"],
        colors: [
          "var( --color-primary-blue-light-2)",
          "var( --color-primary-blue-light)",
        ],
        chart: {
          type: "donut",
          height: 350,
          toolbar: {
            show: false,
          },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 900,
            },
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "22px",
                  fontFamily: "Poppins, sans-serif",
                  color: "#333",
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "1.2rem",
                  fontFamily: "Poppins, sans-serif",
                  color: "#666",
                  offsetY: 10,
                  formatter: function(val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  fontSize: "1.3rem",
                  fontFamily: "Poppins, sans-serif",
                  color: "#000",
                  formatter: function(w) {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                  },
                },
              },
            },
          },
        },
        legend: {
          position: "bottom",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },
  mounted() {
    this.initializeCharts();
    this.getStatistics();
  },
  methods: {
    initializeCharts() {
      this.loading = true;
      try {
        this.chartOptions.series = [
          { name: "Daily Projects", data: this.dailyProjects },
          { name: "Overdue Projects", data: this.overdueProjects },
          { name: "Due Today Projects", data: this.dueTodayProjects },
        ];

        this.resourceChartOptions.series = this.resourceUtilization;
      } catch (error) {
        console.error("Error initializing charts data:", error);
      } finally {
        this.loading = false;
      }
    },
    getStatistics() {
      this.loading = true;
      ProjectService.getChartData()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.chartOptions.series = [
              { name: "Daily Projects", data: response.data.dailyProjects },
              { name: "Overdue Projects", data: response.data.overdueProjects },
              {
                name: "Due Today Projects",
                data: response.data.dailyOverdueProjects,
              },
            ];
            this.resourceChartOptions.series =
              response.data.resourceUtilization;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
  },
};
</script>
